import React, { useState } from "react";
import {
    Box,
    Grid,
    TextField,
    Typography,
    RadioGroup,
    FormControlLabel,
    Radio,
    FormControl,
    FormLabel,
    Select,
    MenuItem,
    Button,
    Container,
    Paper,
} from "@mui/material";

import Checkbox from "@mui/material/Checkbox";

import CampoTextoSamsic from "../Componentes/CampoTextoSamsic";

const AltaTrabajador = () => {
    const [form, setForm] = useState({
        nombre_solicitante: "",
        telefono_solicitante: "",
        email_solicitante: "",

        delegacion: "",

        codigo_trabajador: "",
        nombre_trabajador: "",
        telefono_trabajador: "",

        solicitaCorreo: "no",
        tipoCorreo: "convencional",

        desviarCorreo: "no",
        correoAntecesor: "",
        diasDesvio: "",

        accesoVpn: "no",
        motivoVpn: "",

        tarjeta_fichaje: "no",

        fecha_incorporacion: "",
        departamento: "",

        equipo_informatico: "",
        teclado_adicional: "no",
        pantalla_adicional: "no",

        incluir_listas_correo: [],

        sustituye_trabajador: "no",
        nombre_trabajador_sustituido: "",

        reenviar_correo_sustituido: "no",
        dias_reenvio_correo_sustituido: "",

        observaciones: "",

    });

    const handleCheckboxList = (value) => {
        setForm((prev) => {
            const existe = prev.incluir_listas_correo.includes(value);

            return {
                ...prev,
                incluir_listas_correo: existe
                    ? prev.incluir_listas_correo.filter(v => v !== value)
                    : [...prev.incluir_listas_correo, value],
            };
        });
    };


    const handleChange = (e) => {
        const { name, value } = e.target;

        setForm((prev) => {
            const updated = { ...prev, [name]: value };

            // Si no solicita correo, limpiar todo lo relacionado
            if (name === "solicitaCorreo" && value === "no") {
                updated.tipoCorreo = "convencional";
                updated.desviarCorreo = "no";
                updated.correoAntecesor = "";
                updated.diasDesvio = "";
                updated.incluir_listas_correo = [];
            }


            // Si no se desvía correo, limpiar campos
            if (name === "desviarCorreo" && value === "no") {
                updated.correoAntecesor = "";
                updated.diasDesvio = "";
            }

            if (name === "accesoVpn" && value === "no") {
                updated.motivoVpn = "";
            }

            // Si no sustituye a otro trabajador
            if (name === "sustituye_trabajador" && value === "no") {
                updated.nombre_trabajador_sustituido = "";
                updated.reenviar_correo_sustituido = "no";
                updated.dias_reenvio_correo_sustituido = "";
            }

            // Si no se reenvía el correo
            if (name === "reenviar_correo_sustituido" && value === "no") {
                updated.dias_reenvio_correo_sustituido = "";
            }
            return updated;
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Formulario:", form);
    };

    return (
        <Container maxWidth="md">
            <Paper elevation={3} sx={{ p: 4, mt: 4 }}>

                {/* ===================== CABECERA ====================== */}
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: "auto 1fr auto",
                        alignItems: "center",
                        mb: 3,
                        pb: 2,
                        borderBottom: "1px solid #e0e0e0",
                    }}
                >
                    {/* Logo izquierda */}
                    <Box>
                        <img
                            src="/logoSamsic.jpg"
                            alt="Samsic"
                            style={{ height: 100 }}
                        />
                    </Box>

                    {/* Título centrado */}
                    <Typography
                        variant="h5"
                        fontWeight="bold"
                        textAlign="center"
                    >
                        Formulario Alta Trabajador
                    </Typography>

                    {/* Espaciador derecho (vacío) */}
                    <Box />
                </Box>



                <Box component="form" onSubmit={handleSubmit}>
                    {/* ===================== SOLICITANTE ====================== */}
                    <Typography variant="h6" gutterBottom>
                        Solicitante
                    </Typography>

                    <Grid container spacing={2}>
                        <CampoTextoSamsic
                            label="Nombre del solicitante"
                            name="nombre_solicitante"
                            value={form.nombre_solicitante}
                            onChange={handleChange}
                            xs={6}
                        />

                        <CampoTextoSamsic
                            label="Teléfono"
                            name="telefono_solicitante"
                            value={form.telefono_solicitante}
                            onChange={handleChange}
                            xs={3}
                        />

                        <CampoTextoSamsic
                            label="Email"
                            name="email_solicitante"
                            value={form.email_solicitante}
                            onChange={handleChange}
                            xs={3}
                        />
                    </Grid>

                    {/* ===================== DATOS TRABAJADOR ====================== */}
                    <Typography variant="h6" sx={{ mt: 2 }} gutterBottom>
                        Datos del nuevo trabajador
                    </Typography>

                    <Grid container spacing={2}>
                        <CampoTextoSamsic
                            label="Código"
                            name="codigo_trabajador"
                            value={form.codigo_trabajador}
                            onChange={handleChange}
                            xs={2}
                        />

                        <CampoTextoSamsic
                            label="Nombre"
                            name="nombre_trabajador"
                            value={form.nombre_trabajador}
                            onChange={handleChange}
                            xs={7}
                        />

                        <CampoTextoSamsic
                            label="Teléfono"
                            name="telefono_trabajador"
                            value={form.telefono_trabajador}
                            onChange={handleChange}
                            xs={3}
                        />
                    </Grid>

                    {/* ===================== SUSTITUCIÓN DE TRABAJADOR ====================== */}
                    <Typography variant="h6" sx={{ mt: 2 }} gutterBottom>
                        ¿Sustituye a otro trabajador?
                    </Typography>

                    <Grid container spacing={2}>
                        {/* ¿Sustituye a otro trabajador? */}

                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                {/* <FormLabel>¿Sustituye a otro trabajador?</FormLabel> */}

                                <Grid container spacing={2} alignItems="center">
                                    <Grid item>
                                        <RadioGroup
                                            row
                                            name="sustituye_trabajador"
                                            value={form.sustituye_trabajador}
                                            onChange={handleChange}
                                        >
                                            <FormControlLabel value="no" control={<Radio />} label="No" />
                                            <FormControlLabel value="si" control={<Radio />} label="Sí" />
                                        </RadioGroup>
                                    </Grid>

                                    {form.sustituye_trabajador === "si" && (
                                        <Grid item xs>
                                            <TextField
                                                label="Nombre del trabajador sustituido"
                                                name="nombre_trabajador_sustituido"
                                                value={form.nombre_trabajador_sustituido}
                                                onChange={handleChange}
                                                fullWidth
                                                placeholder="Nombre y apellidos"
                                            />
                                        </Grid>
                                    )}
                                </Grid>
                            </FormControl>
                        </Grid>
                        {form.sustituye_trabajador === "si" && (
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <FormLabel>
                                        ¿Reenviar el correo del trabajador sustituido?
                                    </FormLabel>

                                    <Grid container spacing={2} alignItems="center">
                                        {/* Radios */}
                                        <Grid item>
                                            <RadioGroup
                                                row
                                                name="reenviar_correo_sustituido"
                                                value={form.reenviar_correo_sustituido}
                                                onChange={handleChange}
                                            >
                                                <FormControlLabel value="no" control={<Radio />} label="No" />
                                                <FormControlLabel value="si" control={<Radio />} label="Sí" />
                                            </RadioGroup>
                                        </Grid>

                                        {/* Días de reenvío */}
                                        {form.reenviar_correo_sustituido === "si" && (
                                            <Grid item xs={3}>
                                                <TextField
                                                    label="Días de reenvío"
                                                    name="dias_reenvio_correo_sustituido"
                                                    type="number"
                                                    value={form.dias_reenvio_correo_sustituido}
                                                    onChange={handleChange}
                                                    fullWidth
                                                    inputProps={{ min: 1 }}
                                                />
                                            </Grid>
                                        )}
                                    </Grid>
                                </FormControl>
                            </Grid>
                        )}
                    </Grid>

                    {/* ===================== INCORPORACIÓN ====================== */}
                    <Typography variant="h6" sx={{ mt: 2 }} gutterBottom>
                        Incorporación
                    </Typography>

                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <TextField
                                label="Fecha de incorporación"
                                name="fecha_incorporacion"
                                type="date"
                                value={form.fecha_incorporacion}
                                onChange={handleChange}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        <Grid item xs={8}>
                            <FormControl fullWidth>
                                {/* <FormLabel>Departamento / Rol</FormLabel> */}
                                <Select
                                    name="departamento"
                                    value={form.departamento}
                                    onChange={handleChange}
                                    displayEmpty
                                >
                                    <MenuItem value="">
                                        <em>Selecciona departamento</em>
                                    </MenuItem>
                                    <MenuItem value="Desarrollo">Desarrollo</MenuItem>
                                    <MenuItem value="Explotacion">Explotación</MenuItem>
                                    <MenuItem value="Financiero">Financiero</MenuItem>
                                    <MenuItem value="Operaciones">Operaciones</MenuItem>
                                    <MenuItem value="PRL">PRL</MenuItem>
                                    <MenuItem value="RRHH">RRHH</MenuItem>

                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>


                    {/* ===================== UBICACIÓN ====================== */}
                    <Typography variant="h6" sx={{ mt: 2 }} gutterBottom>
                        Ubicación / Delegación
                    </Typography>

                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <FormControl fullWidth required>
                                <Select
                                    name="delegacion"
                                    value={form.delegacion}
                                    onChange={handleChange}
                                    displayEmpty
                                >
                                    <MenuItem value="">
                                        <em>Selecciona delegación</em>
                                    </MenuItem>
                                    <MenuItem value="Asturias">Asturias</MenuItem>
                                    <MenuItem value="Barcelona">Barcelona</MenuItem>
                                    <MenuItem value="Bilbao">Bilbao</MenuItem>
                                    <MenuItem value="Burgos">Burgos</MenuItem>
                                    <MenuItem value="La Coruña">La Coruña</MenuItem>
                                    <MenuItem value="Madrid">Madrid</MenuItem>
                                    <MenuItem value="San Sebastián">San Sebastián</MenuItem>
                                    <MenuItem value="Santander">Santander</MenuItem>
                                    <MenuItem value="Sevilla">Sevilla</MenuItem>
                                    <MenuItem value="Valencia">Valencia</MenuItem>
                                    <MenuItem value="Valladolid">Valladolid</MenuItem>
                                    <MenuItem value="Zaragoza">Zaragoza</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                    {/* ===================== CORREO ====================== */}
                    <Typography variant="h6" sx={{ mt: 2 }} gutterBottom>
                        Correo
                    </Typography>

                    <Grid container spacing={2} alignItems="flex-start">
                        {/* ¿Solicita correo? */}
                        <Grid item xs={6}>
                            <FormControl>
                                <FormLabel>¿El usuario necesitará correo?</FormLabel>
                                <RadioGroup
                                    row
                                    name="solicitaCorreo"
                                    value={form.solicitaCorreo}
                                    onChange={handleChange}
                                >
                                    <FormControlLabel value="no" control={<Radio />} label="No" />
                                    <FormControlLabel value="si" control={<Radio />} label="Sí" />

                                </RadioGroup>
                            </FormControl>
                        </Grid>

                        {/* Tipo + Desvío */}
                        {form.solicitaCorreo === "si" && (
                            <Grid item xs={6}>
                                <FormControl sx={{ mb: 2 }}>
                                    <FormLabel>Tipo de correo</FormLabel>
                                    <RadioGroup
                                        row
                                        name="tipoCorreo"
                                        value={form.tipoCorreo}
                                        onChange={handleChange}
                                    >
                                        <FormControlLabel
                                            value="convencional"
                                            control={<Radio />}
                                            label="Convencional"
                                        />
                                        <FormControlLabel
                                            value="365"
                                            control={<Radio />}
                                            label="Microsoft 365"
                                        />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        )}

                        {/* ===================== LISTAS DE CORREO ====================== */}
                        {form.solicitaCorreo === "si" && (
                            <Grid container spacing={2} sx={{ mt: 1 }}>
                                <Grid item xs={12}>
                                    <FormControl component="fieldset">
                                        <FormLabel component="legend">
                                            Incluir en listas de correo
                                        </FormLabel>

                                        <Box sx={{ ml: 2 }}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={form.incluir_listas_correo.includes("Comunicacion")}
                                                        onChange={() => handleCheckboxList("Comunicacion")}
                                                    />
                                                }
                                                label="comunicacion@samsic.es"
                                            />

                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={form.incluir_listas_correo.includes("Comunicacion.estructura")}
                                                        onChange={() => handleCheckboxList("Comunicacion.estructura")}
                                                    />
                                                }
                                                label="comunicacion.estructura@samsic.es"
                                            />

                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={form.incluir_listas_correo.includes("Sede.central")}
                                                        onChange={() => handleCheckboxList("Sede.central")}
                                                    />
                                                }
                                                label="sede.central@samsic.es"
                                            />
                                        </Box>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>

                    {/* ===================== ACCESO REMOTO - VPN ====================== */}
                    <Typography variant="h6" sx={{ mt: 4 }} gutterBottom>
                        Acceso Remoto - VPN
                    </Typography>

                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <FormControl>
                                <FormLabel>¿Requiere acceso remoto (VPN)?</FormLabel>
                                <RadioGroup
                                    row
                                    name="accesoVpn"
                                    value={form.accesoVpn}
                                    onChange={handleChange}
                                >
                                    <FormControlLabel value="no" control={<Radio />} label="No" />
                                    <FormControlLabel value="si" control={<Radio />} label="Sí" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>

                        {form.accesoVpn === "si" && (
                            <Grid item xs={12}>
                                <TextField
                                    label="Motivo / Justificación del acceso VPN"
                                    name="motivoVpn"
                                    value={form.motivoVpn}
                                    onChange={handleChange}
                                    fullWidth
                                    multiline
                                    rows={3}
                                    placeholder="Indica por qué el trabajador necesita acceso remoto..."
                                />
                            </Grid>
                        )}
                    </Grid>



                    {/* ===================== Tarjeta de fichaje ====================== */}
                    <Typography variant="h6" sx={{ mt: 4 }} gutterBottom>
                        Tarjeta de fichaje
                    </Typography>

                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <FormControl>
                                <FormLabel>¿Necesita tarjeta de fichaje?</FormLabel>
                                <RadioGroup
                                    row
                                    name="tarjeta_fichaje"
                                    value={form.tarjeta_fichaje}
                                    onChange={handleChange}
                                >
                                    <FormControlLabel value="no" control={<Radio />} label="No" />
                                    <FormControlLabel value="si" control={<Radio />} label="Sí" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    </Grid>

                    {/* ===================== EQUIPAMIENTO IT ====================== */}
                    <Typography variant="h6" sx={{ mt: 4 }} gutterBottom>
                        Equipamiento informático
                    </Typography>

                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <FormLabel>¿Requiere equipo informático?</FormLabel>
                                <Select
                                    name="equipo_informatico"
                                    value={form.equipo_informatico}
                                    onChange={handleChange}
                                    displayEmpty
                                >
                                    <MenuItem value="">
                                        <em>Selecciona tipo de equipo</em>
                                    </MenuItem>
                                    <MenuItem value="Codir">Portátil – Comité directivo</MenuItem>
                                    <MenuItem value="Equipo Reutilizado">Portátil – Equipo Reutilizado</MenuItem>
                                    <MenuItem value="Portatil_Directores">Portátil – Directores de Oficina</MenuItem>
                                    <MenuItem value="Portatil_Gama_Baja">Portátil – Gama baja</MenuItem>


                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={6}>
                            <FormControl>
                                <FormLabel>¿Teclado adicional?</FormLabel>
                                <RadioGroup
                                    row
                                    name="teclado_adicional"
                                    value={form.teclado_adicional}
                                    onChange={handleChange}
                                >
                                    <FormControlLabel value="no" control={<Radio />} label="No" />
                                    <FormControlLabel value="si" control={<Radio />} label="Sí" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>

                        <Grid item xs={6}>
                            <FormControl>
                                <FormLabel>¿Pantalla adicional?</FormLabel>
                                <RadioGroup
                                    row
                                    name="pantalla_adicional"
                                    value={form.pantalla_adicional}
                                    onChange={handleChange}
                                >
                                    <FormControlLabel value="no" control={<Radio />} label="No" />
                                    <FormControlLabel value="si" control={<Radio />} label="Sí" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    </Grid>

                    {/* ===================== OBSERVACIONES ====================== */}
                    <Typography variant="h6" sx={{ mt: 4 }} gutterBottom>
                        Observaciones
                    </Typography>

                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                label="Observaciones adicionales que nos quiera transmitir"
                                name="observaciones"
                                value={form.observaciones}
                                onChange={handleChange}
                                fullWidth
                                multiline
                                rows={4}
                                placeholder="Cualquier información adicional relevante para IT, RRHH o Sistemas…"
                            />
                        </Grid>
                    </Grid>

                    {/* ===================== ACCIONES ====================== */}
                    <Box sx={{ mt: 4, textAlign: "right" }}>
                        <Button variant="contained" type="submit">
                            Enviar Solicitud
                        </Button>
                    </Box>
                </Box>
            </Paper>
        </Container>
    );
};

export default AltaTrabajador;
